export default __webpack_public_path__ + "static/media/quote-testemonials.f25a49e4.svg";